module.exports = __webpack_public_path__ + "img/header_product.d2c83152.png";